import React from "react";
import styles from "./PlanCard.module.scss";

const PlanCard = ({ planName, planAmount }) => {
  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.name}>
          <h5>{planName} Plan</h5>
          <small>/month</small>
        </div>
        <div className={styles.amount}>
          <h4>${planAmount}</h4>
        </div>
      </div>
      <div className={styles.bottom}>
        <ul>
          <li>Upto 10,000 uploads</li>
          <li>10 GB cloud storage</li>
          <li>25 collections</li>
        </ul>
      </div>
    </div>
  );
};

export default PlanCard;
